import { ButtonBaseProps, ButtonProps, SxProps, Theme, TooltipProps } from '@mui/material';
import { ForwardedRef, forwardRef } from 'react';

import { HBIcon, HBIconType } from '../HBIcon/HBIcon';
import { HBIconStyleProps } from '../HBIcon/HBIcon.styles';
import { HBToolTip } from '../HBToolTip/HBToolTip';
import { HBIconButtonRootStyle } from './HBIconButton.styles';
import { JSX } from 'react';
export interface HBIconButtonProps
  extends ButtonBaseProps,
    Pick<TooltipProps, 'placement'>,
    Pick<ButtonProps, 'variant'> {
  icon?: HBIconType | JSX.Element;
  iconSize?: HBIconStyleProps['size'];
  iconStyle?: React.CSSProperties;
  tooltip?: string;
  iconSx?: SxProps<Theme>;
  dataTestId?: string;
}

export const HBIconButton = forwardRef(
  <T extends HTMLButtonElement>(
    {
      icon,
      iconSx,
      tooltip,
      placement,
      iconSize = 'small',
      iconStyle,
      variant = 'outlined',
      ...props
    }: HBIconButtonProps,
    ref: ForwardedRef<T>,
  ) => {
    const IconComponent =
      typeof icon === 'string' ? (
        <HBIcon type={icon} sx={iconSx} size={iconSize} style={iconStyle} />
      ) : (
        icon
      );

    if (tooltip)
      return (
        <HBToolTip title={tooltip} placement={placement} arrow>
          <span>
            <HBIconButtonRootStyle variant={variant} ref={ref} {...props}>
              {IconComponent}
            </HBIconButtonRootStyle>
          </span>
        </HBToolTip>
      );
    return (
      <HBIconButtonRootStyle ref={ref} {...props} variant={variant}>
        {IconComponent}
      </HBIconButtonRootStyle>
    );
  },
);

HBIconButton.displayName = 'HBIconButton';
